export enum NotValidReason {
    None = "None",
    TooManyObjectsOnLayer = "TooManyObjectsOnLayer"
}